<template>
  <div class="products" ref="fullpage">
    <section class="fullpage-section">
      <img src="https://youke1.picui.cn/s1/2025/08/26/68adbbbc40575.png" class="product-image" alt="原鲜冬虫夏草" />
    </section>



    <!-- 加载状态 -->


    <!-- 商品列表容器 - 只有数据加载完成且不为空才显示 -->
    <section class="fullpage-section section-swiper"> <template v-if="goodList.length">
        <div class="buy_list">
          <div v-for="(item, index) in goodList" :key="item.id || index" class="good-item"
            :class="{ 'active': item.showSubItems }">
            <!-- 商品标题 -->
            <div class="item-title">
              {{ item.title }}
            </div>

            <!-- 商品说明 -->
            <div class="item-tips">
              {{ item.tips }}
            </div>

            <!-- 商品类型图片 -->
            <div class="buy-img">
              <img src="https://youke1.picui.cn/s1/2025/08/30/68b2e1dc0f106.png" v-if="item.type === '1'"
                class="content-type" alt="一级产品标识" />
              <img src="https://youke1.picui.cn/s1/2025/08/30/68b2e1dc0664d.png" v-if="item.type === '2'"
                class="content-type" alt="特级产品标识" />
              <img src="https://youke1.picui.cn/s1/2025/08/30/68b3130fd016c.png" v-if="item.type === '3'"
                class="content-type" alt="特级产品标识" />
              <img src="https://youke1.picui.cn/s1/2025/08/30/68b31653c572b.png" v-if="item.type === '4'"
                class="content-type" alt="特级产品标识" />
            </div>

            <!-- 点击触发区域（打开/关闭按钮盒子） -->
            <div class="toggle-container">
              <div class="buy-box" @click="subClick(item, index)">
                <img src="../store/open.png" alt="展开二级商品" class="toggle-icon" v-if="!item.showSubItems" />
                <img src="../store/close.png" alt="收起二级商品" class="toggle-icon" v-if="item.showSubItems" />
              </div>

              <!-- 二级商品列表 -->
              <div class="sub-goods" v-if="item.showSubItems && item.subGoods && item.subGoods.length">
                <div v-for="(subItem, subIndex) in item.subGoods" :key="subItem.id || subIndex" class="sub-goods-item">
                  <div class="sub-title">{{ subItem.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="good_list" v-if="goodList[goodIndex]">
          <div class="good-title">产品- {{ goodList[goodIndex].title }}（{{ typeChange(goodList[goodIndex].type) }}）</div>

          <div class="sp-list" v-if="goodList[goodIndex].subGoods && goodList[goodIndex].subGoods.length">
            <div class="sp-item" v-for="(item, index) in goodList[goodIndex].subGoods" :key="item.id || index">
              <div class="sp-img-box">
                <img :src="item.goodsImg || 'https://picsum.photos/250/200'" alt="商品图片" class="sp-img"></img>
              </div>
              <div class="sp-title">{{ item.title }}</div>
              <div class="sp-tips">{{ item.tips }}</div>
              <div class="sp-bottom">
                <div class="sp-money">
                  ￥{{ item.money }}
                </div>
                <div class="sp-btn" @click="goTabao(item.taobaoUrl)">

                </div>
              </div>
            </div>
          </div>

          <!-- 子商品为空时显示 -->
          <div class="no-subgoods" v-else>
            该类别暂无具体商品
          </div>
        </div>
      </template>
    </section>

    <!-- 右侧导航点 -->
    <div class="page-dots">
      <span v-for="(dot, index) in 2" :key="index" class="dot" :class="{ active: activeIndex === index }"
        @click="scrollToSection(index)"></span>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { getProductListAsync } from '../utils/mock';

// 状态管理
const goodIndex = ref(0);
const goodList = ref([]);
const loading = ref(true);
const error = ref(null);
const buyTitleBg = ref("");


/** ---------------- 整屏滚动逻辑（保留原功能） ---------------- **/
const activeIndex = ref(0) // 当前激活的屏幕索引
const fullpage = ref(null) // 整屏容器DOM引用

// 点击导航点跳转对应屏幕
const scrollToSection = (index) => {
  const el = fullpage.value.children[index]
  el.scrollIntoView({ behavior: "smooth" })
  activeIndex.value = index
}

onMounted(() => {
  // 监听滚动，更新导航点激活状态
  fullpage.value.addEventListener("scroll", () => {
    const sections = fullpage.value.children
    let current = 0
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].getBoundingClientRect().top >= 0) {
        current = i
        break
      }
    }
    activeIndex.value = current
  })
})

// 处理商品类型转换
const typeChange = (index) => {
  const typeMap = {
    '1': '2400',
    '2': '3200',
    '3': '3600',
    '4': '4600'
  };
  return typeMap[index] || '';
};

// 处理子商品点击
const subClick = (item, curIndex) => {
  // 关闭其他项，切换当前项状态
  goodList.value = goodList.value.map((item, index) => ({
    ...item,
    showSubItems: index === curIndex ? !item.showSubItems : false
  }));
  goodIndex.value = curIndex;
};

const goTabao = (url) => {
  console.log(url, "213123");

  window.open(url, "_blank")
}

// 数据获取函数
const fetchData = async () => {
  console.log("fetchData");

  try {
    loading.value = true;
    error.value = null;

    const res = await getProductListAsync();

    if (res.code === 200) {
      const productSection = res.data.sectionList?.find(sec => sec.sectionType === 'PRODUCT_CLASS_LIST');

      if (productSection && productSection.productClassList?.length) {
        // 处理商品数据，确保每个商品都有必要属性
        goodList.value = productSection.productClassList.map(classItem => ({
          id: classItem.productClass.id || Date.now() + Math.random(), // 确保有唯一ID
          title: classItem.productClass.name || '未知商品',
          tips: classItem.productClass.desc || '',
          type: classItem.productClass.type || '',
          imageUrl: classItem.productClass.icon || '',
          goodsImg: classItem.productList[0]?.goodsImg || '',
          subGoods: classItem.productList || [],
          showSubItems: classItem.productClass.showSubItems ?? false
        }));
        goodIndex.value = 0;
        console.log(goodList.value, " goodList.value");

      } else {
        goodList.value = [];
      }
    } else {
      throw new Error(`获取数据失败，错误码: ${res.code}`);
    }
  } catch (err) {
    console.error('获取商品数据失败：', err);
    error.value = err.message || '未知错误';
    // 提供默认数据，避免空页面
    goodList.value = [
      {
        id: 'default-1',
        title: '默认商品',
        tips: '加载数据失败时显示的默认商品',
        type: '1',
        subGoods: [
          {
            id: 'default-sub-1',
            title: '默认子商品',
            tips: '请检查网络后重试',
            money: '0.00',
            goodsImg: 'https://picsum.photos/250/200'
          }
        ],
        showSubItems: false
      }
    ];
  } finally {
    loading.value = false;
  }
};

// 页面加载时获取数据
fetchData();
</script>

<style scoped>
/* 原有样式保持不变 */
.sp-list {
  display: flex;
  padding-top: 30px;
  gap: 30px;
  padding-bottom: 50px;
  flex-wrap: wrap;
  /* 增加换行，避免溢出 */
}

.sp-item {
  width: 20%;
  min-width: 250px;
  /* 增加最小宽度，避免过小 */
  height: 480px;
  border-radius: 10px;
  background: linear-gradient(#FCF8EF, #F4E7D4);
  padding: 15px;
  box-sizing: border-box;
}

.sp-img-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
}

.sp-img {
  width: 250px;
  height: 200px;
  object-fit: contain;
  /* 确保图片完整显示 */
}

.sp-title {
  color: #53423A;
  font-size: 22px;
  text-align: center;
  font-weight: bold;
}

.sp-tips {
  color: #B08D6D;
  font-size: 16px;
  text-align: center;
  margin: 10px 0;
}

.sp-bottom {
  border-top: 1px solid #DBC6B3;
  margin-top: 20px;
  padding-top: 15px;
}

.sp-money {
  font-size: 28px;
  color: #9A7956;
  font-weight: bold;
  text-align: center;
}

.sp-btn {
  background: url("https://youke1.picui.cn/s1/2025/08/30/68b2dc33767d0.png") no-repeat;
  background-size: contain;
  background-position: center;
  width: 130px;
  font-size: 20px;
  padding: 5px;
  text-align: center;
  border-radius: 20px;
  margin: auto;
  margin-top: 15px;
  height: 40px;
  /* 调整高度，避免过大 */
  line-height: 40px;
  cursor: pointer;
  color: #fff;
}

.good_list {
  color: #66554E;
  border-bottom: 1px solid #66554E;
  min-width: 1350px;
  width: 80%;
  margin: auto;
  font-size: 26px;
  padding: 20px 0;
}

/* 页面整体样式 */
.products {
  background: linear-gradient(#F8F8F6, #F1EBDF);

  min-width: 1400px;

}

/* .fullpage-wrapper {
  height: calc(100vh - 100px);
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  position: relative;
} */

/* 顶部产品图片 */
.product-image {
  width: 100%;
  height: auto;
}

/* 商品列表容器 */
.buy_list {
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  padding-bottom: 100px;
  justify-content: space-between;
  margin-top: 80px;
  gap: 20px;
  min-width: 1350px;
}

/* 单个商品卡片 */
.good-item {
  position: relative;
  background: url("https://youke1.picui.cn/s1/2025/08/30/68b2e2addbd3d.png") no-repeat;
  background-size: 100% 100%;
  width: 23%;
  min-width: 280px;
  /* 增加最小宽度 */
  height: 480px;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;
}

.good-item.active {
  transform: translateY(-80px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.item-title {
  color: #F3EBE0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-top: 120px;
  padding: 0 10px;
}

.item-tips {
  color: #5B493D;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
}

.buy-img {
  width: 100%;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-type {
  width: 250px;
  height: 250px;
  object-fit: contain;
  margin-top: 120px;
}

.toggle-container {
  border-top: 1px solid #D8C1AF;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.buy-box {
  border-top: 1px solid #D6C1B0;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.3s ease;
}

.toggle-icon {
  width: 30px;
  height: 30px;
  margin-top: 10px;
  transition: transform 0.2s ease;
}

.buy-box:active .toggle-icon {
  transform: scale(0.9);
}

.sub-goods {
  background-color: rgba(255, 255, 255, 0.95);
  width: 100%;
  padding: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  animation: fadeUp 0.3s ease forwards;
  z-index: 1;
  height: 0;
  overflow: hidden;
}

.good-item.active .sub-goods {
  height: auto;
}

.sub-goods-item {
  border-bottom: 1px dashed #D6C1B0;
  padding: 8px 0;
}

.sub-goods-item:last-child {
  border-bottom: none;
}

.sub-title {
  font-weight: 600;
  color: #52443B;
  font-size: 16px;
  text-align: center;
}

.sub-tips {
  color: #5B493D;
  font-size: 14px;
  margin-top: 3px;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 新增状态样式 */
.loading-state,
.error-state,
.empty-state,
.no-subgoods {
  text-align: center;
  padding: 50px 0;
  color: #5B493D;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border: 4px solid rgba(91, 73, 61, 0.1);
  border-left-color: #9A7956;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.retry-btn {
  background-color: #9A7956;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 15px;
  font-size: 16px;
}

.retry-btn:hover {
  background-color: #86694c;
}

.no-subgoods {
  padding: 30px 0;
  font-size: 18px;
}

.fullpage-section {
  /* height: 100vh; */
  scroll-snap-align: start;
}

/* 右侧导航点 */
.page-dots {
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
  transition: background 0.3s, transform 0.3s;
}

.dot.active {
  background: #fff;
}
</style>
